



















import Vue, { PropType } from 'vue'
import GridPageHead from '@/pages/common/grid-parts/GridPageHead.vue'
import BaseButton from '@/ui/button/BaseButton.vue'
import { loadModalForMultiChanges } from '@/pages/bank/test-tasks/list/parts/modals/tasks-update/tasks-update-modal.model'
import HeaderPopup from '@/pages/common/parts/header/header-popup/HeaderPopup.vue'
import { TableField } from '@/pages/dictionary/themes/list/types'
import DownloadButton from '@/pages/common/parts/header/DownloadButton.vue'
import { testTaskPageParams } from '@/pages/bank/test-tasks/list/tasks-page.model'
import { $permissions } from '@/features/session'

export default Vue.extend({
  name: 'LessonsHeader',
  components: {
    DownloadButton,
    BaseButton,
    GridPageHead,
    HeaderPopup,
  },
  props: {
    tableColumns: { type: Array as PropType<TableField[]> },
    selectedRows: { type: Array as PropType<number[]> },
  },
  effector: {
    $treeView: testTaskPageParams.store.treeView,
    $permissions,
  },
  methods: {
    loadModalForMultiChanges,
  },
})
